import React from "react";
import PropTypes from "prop-types";
import Button from "@paprika/button";
import Modal from "@paprika/modal";
import i18n from "@viz-ui/i18n/i18n";
import DownloadXlsBody, { XLS_CELL_LIMIT_EXCEEDED_ERROR_KEY } from "./DownloadXlsBody";
import "./DownloadXlsModal.scss";

const propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onExportToCsv: PropTypes.func,
  isExportToCsvEnabled: PropTypes.bool,
};

const defaultProps = {
  isOpen: false,
  onExportToCsv: undefined,
  isExportToCsvEnabled: true,
};

const initialBodyState = {
  isRunning: true,
  hasError: false,
  errorMessageKey: null,
};

export default function DownloadXlsModal(props) {
  const { isOpen, onClose, onExportToCsv, isExportToCsvEnabled } = props;
  const refHeading = React.useRef(null);
  const [bodyState, setBodyState] = React.useState(initialBodyState);
  const modalTitle = i18n.t("_ActionButtons.ExportXls.Label_");
  const isCellLimitError = bodyState.errorMessageKey === XLS_CELL_LIMIT_EXCEEDED_ERROR_KEY;
  const showFooter = bodyState.hasError;

  const handleFocus = () => {
    refHeading.current.focus();
  };

  const handleExportToCsv = () => {
    if (!isExportToCsvEnabled) {
      return;
    }
    onClose();
    if (onExportToCsv) {
      onExportToCsv();
    }
  };

  React.useEffect(() => {
    if (!isOpen) {
      setBodyState(initialBodyState);
    }
  }, [isOpen]);

  return (
    <Modal
      a11yText={modalTitle}
      className="download-xls-modal"
      isOpen={isOpen}
      onClose={onClose}
      onAfterOpen={handleFocus}
      size="small"
      zIndex={220}
    >
      <Modal.Header refHeading={refHeading} level={2}>
        {modalTitle}
      </Modal.Header>
      <Modal.Content>{isOpen ? <DownloadXlsBody onStatusChange={setBodyState} /> : null}</Modal.Content>
      {showFooter && (
        <Modal.Footer className="modal-footer">
          {isCellLimitError && onExportToCsv && isExportToCsvEnabled && (
            <Button
              className="footer-button--confirm"
              kind="primary"
              onClick={handleExportToCsv}
              data-testid="export-csv-button"
            >
              {i18n.t("_ActionButtons.ExportCsv.Label_")}
            </Button>
          )}
          <Button className="footer-button--cancel" data-testid="cancel-button" kind="minor" onClick={onClose}>
            {i18n.t("_General.Cancel.Label_")}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

DownloadXlsModal.propTypes = propTypes;
DownloadXlsModal.defaultProps = defaultProps;
